module.exports = __webpack_public_path__ + "img/message.027f0048.jpg";